import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateProductValue } from '../../../Actions/Configurator/Configurator.action';
import { translate } from "../../../Services/translation";
import { addMultiple } from '../../../Actions/Cart.action';
import ProductSummaryModuleItem from './ProductSummaryModuleItem';
import { post } from '../../../Services/http';
import ConfiguratorSharePopUp from '../ConfiguratorSharePopUp';

const ProductSummaryModule = (props) => {
    const dispatch = useDispatch();
    const { products, handBookFile, configuratorId, preCheckoutText } = useSelector((state) => state.productConfigurator.payload);    
    const itemRef = useRef(null);
    const [hasScrolledIntoView, setHasScrolledIntoView] = useState(false);
    const [showShareModal, setshowShareModal] = useState(false);

    useEffect(() => {
        if (products.some(x => x.calculatedQuantity > 0) && !hasScrolledIntoView) {
            itemRef.current.scrollIntoView({ behavior: 'smooth' });
            setHasScrolledIntoView(true);
        }
    }, [products, hasScrolledIntoView]);

    const addToCart = () => {
        const selectedProducts = products.filter(product => product.confirmedQuantity > 0);
        dispatch(addMultiple(selectedProducts, configuratorId));
    }

    const getTotalProductSum = () => {
        const validProducts = products.filter(product => product.confirmedQuantity > 0);
        let total = validProducts.reduce((accum, item) => {
            const price = item.productCampaignPrice !== 0 ? item.productCampaignPrice: item.productPrice;
            return accum + (price * item.confirmedQuantity);
        }, 0);
        return formatPrice(total);
    }

    const formatPrice = (value, separator = ' ') => {
        const stringValue = setNumberOfDecimals(value)
        return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    };

    const setNumberOfDecimals = (value) => {
        let string = value.toString();
        let number = parseFloat(string);
        string = number.toFixed(2).replace(/(\.\d*?[1-9])0+$|\.0*$/, '$1');
        return string;
    };    

    const hideShareModal = () => {
        setshowShareModal(false);
    }

    return (
        <Fragment>
            <div ref={itemRef} className='configurator__summary'>
                <div className='content-wrapper'>
                {products && products.some(x => x.confirmedQuantity > 0) && <>
                    <h3 className='title'>{translate("wallConfiguratorRecommendedProducts")}</h3>
                    <p className='text'>{translate("wallConfiguratorProductSelectionTip")}</p>
                    <div className='configurator__product-summary-container'>
                        {products                            
                            .map((item, index) => (
                            item.calculatedQuantity > 0 && <ProductSummaryModuleItem
                            key={`${item.articleNumber}${item.calculatedQuantity}`}
                                item={item}
                                isSelected={item.confirmedQuantity > 0}
                                onQuantityChange={(newQuantity) => dispatch(updateProductValue(item.articleNumber, newQuantity))}
                                />
                            ))}
                    </div>  
                    <div className='configurator__download'>
                        <div className='link-wrapper'>
                            <a href={handBookFile} target="_blank">{translate("downloadHandbook")}</a>
                            <a onClick={() => setshowShareModal(true)}>{translate("configuratorSend")}</a>
                        </div>
                        <p className='description'>{translate("productConfiguratorDisclaimer")}</p>
                        <div className='pre-checkout-text' 
                            dangerouslySetInnerHTML={{
                                __html: preCheckoutText
                            }}>
                        </div>
                    </div>
                    <div className='configurator__add-to-cart'>
                        <button onClick={addToCart}>{translate("productConfiguratorAddToCart")}</button>
                        <div className='summary'>
                            <p className='summary__text'>{translate("totalCost")}</p>
                            <p className='summary__price'>{getTotalProductSum()} {"kr"}</p>
                        </div>
                    </div>

                    {showShareModal && <ConfiguratorSharePopUp key={showShareModal} 
                    shareModalIcon={props.shareModalIcon} shareModalHeader={props.shareModalHeader}
                    shareModalDescription={props.shareModalDescription} shareModalTipsDescription={props.shareModalTipsDescription}
                    hideShareModal={() => hideShareModal()}></ConfiguratorSharePopUp>}                
                </>}
                </div>
            </div>
        </Fragment>
    );
}

export default ProductSummaryModule;